import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import Toggle from "../sidebar/Toggle";
import Logo from "../logo/Logo";
import User from "./dropdown/user/User";
import Notification from "./dropdown/notification/Notification";
import * as Paho from "paho-mqtt";
import Toast from "../../utils/Toast";

import { useTheme, useThemeUpdate } from "../provider/Theme";
import OnlinePlayers from "./dropdown/onlinePlayers/OnlinePlayers";
import OfflinePlayers from "./dropdown/offlinePlayers/OfflinePlayers";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const Header = ({ mode, changeMode, fixed, className, lightVersion, ...props }) => {
  const theme = useTheme();
  const themeUpdate = useThemeUpdate();
  const navigate = useNavigate();
  
  // Check if dark mode is active
  const isDarkMode = !lightVersion;

  const [hasNotifications, setHasNotifications] = useState(false);
  const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);

  const headerClass = classNames({
    "nk-header": true,
    "nk-header-fixed": fixed,
    [`is-light`]: mode === "white" || mode === "light",
    [`is-${theme.header}`]: (mode === "white") !== "white" && mode !== "light",
    [`${className}`]: className,
  });

  //-------------------------------------------------------------------------------------
  let client = null;
  let configs = JSON.parse(localStorage.getItem("configuration_data"));
  const mqttIp = configs !== null ? configs["ip"] : "";
  const mqttPort = configs !== null ? configs["port"] : "";
  const mqttUsername = configs !== null ? configs["mq-username"] : "";
  const mqttPassword = configs !== null ? configs["mq-password"] : "";
  const ssl = configs !== null ? configs["use-ssl"] === "true" : false;

  const baseUrl = localStorage.getItem("API_URL");
  const token = localStorage.getItem("user_token");
  const userDetails = JSON.parse(localStorage.getItem("user_details"));

  const [playersCount, setPlayersCount] = useState({});

  // useEffect(() => {
  //   if (localStorage.getItem("configuration_data") === undefined || localStorage.getItem("configuration_data") === null)
  //     configurationData();

  //   getPlayersCount();
  //   connectMqtt();

  //   const intervalId = setInterval(getPlayersCount, 30000);
  //   return () => {
  //     clearInterval(intervalId);
  //     if (client) {
  //       if (client.isConnected()) {
  //         client.unsubscribe(`signage:notification:user:${userDetails.userId}`);
  //         client.disconnect();
  //       }
  //     }
  //   };
  // }, []);

  useEffect(() => {
    // getValidity();
  }, []);

  // get players count - function
  // const getPlayersCount = () => {
  //   axios({
  //     method: "GET",
  //     url: `${baseUrl}/player/get-status/counts`,
  //     headers: {
  //       Authorization: token,
  //     },
  //   })
  //     .then((res) => {
  //       let data = res.data.data;
  //       setPlayersCount(data);
  //       Toast("close");
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       // if (error.response !== undefined) {
  //       //   Toast("close");
  //       //   Toast("error", error.response.data.message);
  //       // } else {
  //       //   Toast("close");
  //       //   Toast("error", "Something went wrong");
  //       // }
  //       if (error.response.status === 401) {
  //         localStorage.removeItem("user_token");
  //         localStorage.removeItem("user_details");
  //         window.location = "/";
  //       }
  //     });
  // };

  const getValidity = () => {
    axios({
      method: "GET",
      url: `${baseUrl}/user/require-reset`,
      headers: {
        Authorization: token,
      },
    })
      .then((res) => {
        let data = res.data.data;
        console.log(data);
        if (data === true) {
          Swal.fire({
            title: "Password Reset",
            text: "Please change your password to proceed",
            confirmButtonText: "Proceed",
            allowOutsideClick: false,
          }).then(() => {
            navigate(`${process.env.PUBLIC_URL}/reset-pw`, {
              state: { type: 1 },
            });
          });
        }
        // if (data !== true) {
        //   Swal.fire({
        //     title: "Password Reset",
        //     text: "Please change your password to proceed",
        //     // icon: "question",
        //     allowOutsideClick: false,
        //     input: "text",
        //     confirmButtonText: "Reset",
        //     preConfirm: async (password) => {
        //       axios({
        //         method: "POST",
        //         url: `${baseUrl}/user/own-pw-resett`,
        //         headers: {
        //           Authorization: token,
        //         },
        //         data: {
        //           newPassword: password,
        //         },
        //       })
        //         .then((res) => {
        //           Toast("success", "Password reset successful!");
        //         })
        //         .catch((error) => {
        //           // console.log(error);
        //           Toast("error", "Something went wrong");
        //           Swal.fire({
        //             title: "Cancelled",
        //             text: "Your imaginary file is safe :)",
        //             icon: "error",
        //           });
        //         });
        //     },
        //   }).then((result) => {
        //     if (result.isConfirmed) {
        //       Swal.fire({
        //         title: ` avatar`,
        //       });
        //     }
        //   });
        // }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const connectMqtt = () => {
    if (mqttIp && mqttPort) {
      client = new Paho.Client(mqttIp, Number(mqttPort), "mqttjs_" + new Date().getTime());

      client.onConnectionLost = onConnectionLost;
      client.onMessageArrived = onMessageArrived;
      client.connect({
        onSuccess: onConnect,
        onFailure: onFailure,
        userName: mqttUsername,
        password: mqttPassword,
        reconnect: true,
        useSSL: ssl,
      });
    }
  };

  const onConnect = () => {
    client.subscribe(`signage:notification:user:${userDetails.userId}`);
  };

  const onFailure = (e) => {
    console.log("Connection failed: " + e.errorMessage);
  };

  const onConnectionLost = (responseObject) => {
    if (responseObject.errorCode !== 0) {
      console.log("onConnectionLost:" + responseObject.errorMessage);
    }
  };

  const onMessageArrived = (msg) => {
    // setPlayerScreenshot(msg.payloadString);
    let payloadJSON = JSON.parse(msg?.payloadString);
    msg.payloadString && Toast("mqtt", payloadJSON?.title);
  };

  const configurationData = () => {
    axios({
      method: "POST",
      url: `${baseUrl}/player/get-config-values`,
      headers: {
        Authorization: token,
      },
      data: {
        response: ["mq-password", "mqtt", "web-socket", "mq-username", "ip", "port", "use-ssl", "scrapy-base-url"],
      },
    })
      .then((res) => {
        let data = res.data.data;
        localStorage.setItem("configuration_data", JSON.stringify(data));
        configs = data;
      })
      .catch((error) => {
        console.log(error);

        if (error.response.status === 401) {
          navigate(`${process.env.PUBLIC_URL}`);
          navigate(0);

          Toast("close");
          Toast("error", "Unauthorized");
          // return;
        }
      });
  };

  return (
    <div className={headerClass}>
      <div className="container-fluid">
        <div className="nk-header-wrap">
          <div className="nk-menu-trigger d-xl-none ms-n1">
            <Toggle
                className="nk-nav-toggle nk-quick-nav-icon d-xl-none ms-n1"
                icon="menu"
                click={themeUpdate.sidebarVisibility}
                style={{ color: isDarkMode ? '#fff' : '#333', display: 'inline-flex' }}
            />
          </div>
          <div className="nk-header-brand  ">
            <Logo/>
          </div>
          <span style={{marginTop: '7px', marginLeft:'-7px', color:'#5b5cf5'}} className={' text-large'}>QUEUE</span>
          <div className="nk-header-news d-none d-xl-block">
            {/* <News /> */}

            {/*<ul className="nk-quick-nav">*/}
            {/*  <li className="notification-dropdown me-n1">*/}
            {/*    <OnlinePlayers playersCount={playersCount} />*/}
            {/*  </li>*/}
            {/*  <li className="notification-dropdown me-n1">*/}
            {/*    <OfflinePlayers playersCount={playersCount} />*/}
            {/*  </li>*/}
            {/*</ul>*/}
          </div>
          <div className="nk-header-tools">

            <ul className="nk-quick-nav">
              {userDetails.userType === 4 ? (
                <>
                  {hasNotifications ? (
                      <li
                          className="user-dropdown"
                          style={{ color: '#fff', position: 'relative', cursor:"pointer" }}
                          onClick={() => {navigate('/notification-manager')}}
                      >
                        <i className="fa fa-bell"></i>

                        {hasUnreadNotifications ? (
                            <span
                                style={{
                                  position: 'absolute',
                                  top: '2px',
                                  right: '2px',
                                  width: '8px',
                                  height: '8px',
                                  backgroundColor: 'red',
                                  borderRadius: '50%',
                                }}
                            ></span>
                        ) : <></>}
                      </li>
                  ) : (
                      <li className="user-dropdown">
                        <i className="fa fa-bell"></i>
                      </li>
                  )}
                </>
              ) : null}
              <li className="user-dropdown" onClick={themeUpdate.sidebarHide}>
                <User setHasNotifications={setHasNotifications} hasNotifications={hasNotifications} setHasUnreadNotifications={setHasUnreadNotifications}/>
              </li>
              {/* Notification icon */}
              {/*<li className="notification-dropdown me-n1" onClick={themeUpdate.sidebarHide}>*/}
              {/*  <Notification mode={mode} changeMode={changeMode}/>*/}
              {/*</li>*/}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = state => ({
  lightVersion: state.settings?.lightVersion || false,
});

export default connect(mapStateToProps)(Header);
